# inview.coffee
# Check to see if an element is in view.

$ = require 'jquery'

module.exports =
  inView: ($element) ->
    docViewTop = $(window).scrollTop()
    docViewBottom = docViewTop + $(window).height()
    elemTop = $($element).offset().top
    elemBottom = elemTop + $($element).height()
    return ((elemBottom <= docViewBottom) and (elemTop >= docViewTop))

  partiallyInView: ($element) ->
    if not $element.is(':visible')
      return false

    docViewTop = $(window).scrollTop()
    docViewBottom = docViewTop + $(window).height()
    elemTop = $($element).offset().top
    elemBottom = elemTop + $($element).height()

    if elemTop >= docViewTop and elemTop <= docViewBottom or
    elemBottom >= docViewTop and elemBottom <= docViewBottom
      inView = true
    else
      inView = false
    return inView
